import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ReportDataService } from 'src/app/services/report-data.service';
import { take, tap } from 'rxjs/operators';
import { LogsPerHourStat } from 'src/app/models/chart-data';
import { PlotlyService, PlotlyComponent } from 'angular-plotly.js';
import { PlotlyHTMLElement } from 'plotly.js';


@Component({
  selector: 'app-dev-errors-widget',
  templateUrl: './dev-errors-widget.component.html',
  styleUrls: ['./dev-errors-widget.component.less']
})
export class DevErrorsWidgetComponent implements OnInit, AfterViewInit {
  public loaded: boolean = true;
  @ViewChild('cmp') input : PlotlyComponent;
  @ViewChild('plot2') plot2;
  public graph = {
     data: [],
    //     // { x: [1, 2, 3], y: [2, 6, 3], type: 'scatter', mode: 'lines+points', marker: {color: 'red'} }]
    //     // { x: [1, 2, 3], y: [2, 5, 3], type: 'bar' },
    // ,
    layout: { autosize: true, title: 'Errors Last 48 Hours'}
};
  constructor( public rptDta : ReportDataService,public plotly: PlotlyService) { }
  ngAfterViewInit(): void {
    this.input.update.subscribe(ev => {
      console.log('update',ev);
    });
  }
  errorCounts : LogsPerHourStat[]
  ngOnInit(): void {
    this.rptDta.getErrorsLast48Hours().pipe(
      take(1),
      tap(_=>{ this.errorCounts = _}))
    .subscribe(()=>{
      console.log(this.errorCounts);
      let dtas = {
        x: this.errorCounts.map(ec =>{ return ec.index; }),
        y:this.errorCounts.map(ec =>{ return ec.errorsPerHour; }),
        text : this.errorCounts.map(ex =>{return ex.dataLabel;}),
        type: 'scatter',
        name: `Error Per Hour(last 48 hours)`,
        mode: 'lines+points',
        marker: {
          color: 'blue',
        }
      };
      this.plotly.update(this.input.plotlyInstance,[dtas],this.graph.layout);
    },(err: any) => {
      
    });
  }
}
